import { render, staticRenderFns } from "./generalInfo.vue?vue&type=template&id=da40d7c8&scoped=true&"
import script from "./generalInfo.vue?vue&type=script&lang=js&"
export * from "./generalInfo.vue?vue&type=script&lang=js&"
import style0 from "./generalInfo.vue?vue&type=style&index=0&id=da40d7c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da40d7c8",
  null
  
)

export default component.exports